module.exports = __webpack_public_path__ + "static/img/03.37c6576.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dymanticLanshu/03.jpg
// module id = knDn
// module chunks = 0